import React from 'react';
import '../styles/ahead.css';
import aheadImg from '../../../../assets/company/aboutus/ahead.svg';

const ahead = () => {
    return (
        <section className="ahead-section">
            <div className="ahead-container">
                <div className="ahead-image">
                    <img
                        src={aheadImg}
                        alt="We’ve always done things differently"
                        className="ahead-img"
                    />
                </div>
                <div className="ahead-content">
                    <h2 className="ahead-title">
                        Looking Ahead
                    </h2>
                    <p className="ahead-description">
                        As technology continues to evolve, Synectiks remains committed to helping businesses thrive in a cloud-first, AI-driven, security-critical world.
                        By combining expertise in endpoint security, backup and disaster recovery, secure cloud hosting, Desktop as a Service, Microsoft 365 Copilot enablement, and application modernization, we help organizations modernize with speed, agility, and confidence-making transformation faster, smarter, and more cost-effective than ever before.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default ahead;
